import React, {useEffect, useState} from 'react'
import MarkDownRenderer from '../MarkdownRender'
import {Grid} from '@material-ui/core/'
import PdfViewer from '../PdfViewer/PdfViewer'
import BrowserCompatibility from '../BrowserCompatibilty'

const Footer = props => {
    const footer = props.footer
    const privacyProps = footer.footerPrivacyPolicyProps || null
    const [isTermOpen, setIsTermOpen] = useState(false)

    const privacyClick = () => {
        setIsTermOpen(true)
    }

    return (
        <div
            style={{
                textAlign: 'center',
                bottom: 0,
                right: 0,
                lineHeight: '25px',
                width: '100%',
            }}
        >
            <div className="footer-wrapper">
                {' '}
                {privacyProps &&
                    ((privacyProps.openOnNewTab && (
                        <a
                            className="privacy__policy"
                            href={privacyProps.pdfViewProp.pdfViewURL}
                            target="_blank"
                        >
                            {privacyProps.PrivacyPolicyText || ''}
                        </a>
                    )) || (
                        <a className="privacy__policy" onClick={privacyClick}>
                            {privacyProps.PrivacyPolicyText || ''}
                        </a>
                    ))}
            </div>
            <div className="footer-wrapper">
                <MarkDownRenderer value={footer.copyrightLeftText} />
                {`© ${new Date().getFullYear()}`}
                <MarkDownRenderer value={footer.copyright} />

                {isTermOpen && privacyProps && (
                    <PdfViewer
                        {...privacyProps.pdfViewProp}
                        isHide={setIsTermOpen}
                    ></PdfViewer>
                )}
                {footer.customization &&
                    footer.customization.browserSupported &&
                    process.env.REACT_APP_SUPPORTED_BROWSER_TEXT && (
                        <div className="supported__browser">
                            <BrowserCompatibility />
                        </div>
                    )}
            </div>
        </div>
    )
}
export default Footer
